var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4442 15.6515L39.4446 15.6526C39.5844 16.0833 39.4548 16.5528 39.1138 16.8512L39.113 16.8519L30.3862 24.5038L29.9385 24.8964L30.0703 25.4771L32.6435 36.812C32.7437 37.2543 32.5722 37.7104 32.2053 37.9763L32.2052 37.9764C31.8389 38.2418 31.3546 38.2619 30.9708 38.031L30.9685 38.0296L21.0134 32.0776L20.5003 31.7709L19.9872 32.0776L10.0284 38.0296L10.028 38.0298C9.84618 38.1386 9.64851 38.1913 9.45164 38.1913C9.2223 38.1913 8.99254 38.1202 8.79213 37.9754C8.42721 37.7115 8.25476 37.2568 8.35506 36.812C8.3551 36.8118 8.35513 36.8116 8.35517 36.8115L10.9282 25.4771L11.0601 24.8964L10.6124 24.5039L1.88569 16.8505L1.8838 16.8488C1.54542 16.5536 1.41557 16.084 1.55566 15.6532C1.69561 15.2228 2.07456 14.9197 2.52458 14.8779C2.52475 14.8779 2.52492 14.8779 2.52508 14.8779L14.0704 13.8297L14.6649 13.7757L14.8995 13.2267L19.4643 2.54438C19.4644 2.54409 19.4645 2.54381 19.4646 2.54352C19.6445 2.12493 20.0506 1.8584 20.5002 1.8584C20.9501 1.8584 21.3563 2.12524 21.536 2.54219C21.5362 2.54257 21.5363 2.54295 21.5365 2.54332L26.1009 13.2267L26.3354 13.7757L26.93 13.8297L38.4751 14.878L38.4758 14.8781C38.926 14.9186 39.3055 15.2225 39.4442 15.6515Z",
    stroke: "#DADADA",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutline);
export default __webpack_public_path__ + "static/media/star-outline.c702c08023250e3ea215af7da4ffe0e2.svg";
export { ForwardRef as ReactComponent };